import { AxiosResponse } from 'axios';
import {
  SET_LEAVE_LEDGER,
  SET_LEAVE_LEDGERS,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  CLEAR_LEAVE_LEDGER_ISLOADING,
  DELETE_LEAVE_LEDGER,
  EDIT_LEAVE_LEDGER,
  GET_LEAVE_LEDGERS,
  GET_LEAVE_LEDGER,
  REGISTER_LEAVE_LEDGER,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import LeaveLedgerService from '@/services/leave_ledger';
import { Module } from 'vuex';
import {
  EditLeaveLedger,
  GetLeaveLedger,
  RegisterLeaveLedger,
} from '@/dtos/leave_ledger.dto';

const leaveLedger: Module<any, {}> = {
  state: {
    leaveLedger: {
      data: null,
      isLoading: false,
    },
    leaveLedgers: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    leaveLedger: (state: { leaveLedger: any }) => state.leaveLedger,
    leaveLedgers: (state: { leaveLedgers: any }) => state.leaveLedgers,
  },
  mutations: {
    [SET_LEAVE_LEDGER]: (
      state: { leaveLedger: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveLedger.data = payload.data) : null;
      state.leaveLedger.isLoading = payload.isLoading;
    },
    [SET_LEAVE_LEDGERS]: (
      state: { leaveLedgers: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveLedgers.data = payload.data) : null;
      state.leaveLedgers.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_LEAVE_LEDGER]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_LEDGER, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveLedgerService.registerLeaveLedger(
        payload as RegisterLeaveLedger
      );

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_LEDGER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_LEDGER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_LEDGER, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_LEDGERS]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_LEDGERS, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveLedgerService.getLeaveLedgers(
        payload as GetLeaveLedger
      );

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_LEDGERS, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_LEAVE_LEDGERS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_LEDGERS, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_LEDGER]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_LEDGER, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveLedgerService.getLeaveLedger(
        payload as GetLeaveLedger
      );

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_LEDGER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_LEDGER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_LEDGER, { isLoading: false });
        return false;
      }
    },
    [EDIT_LEAVE_LEDGER]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_LEDGER, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveLedgerService.editLeaveLedger(
        payload as EditLeaveLedger
      );

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_LEDGER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_LEDGER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_LEDGER, { isLoading: false });
        return false;
      }
    },
    [DELETE_LEAVE_LEDGER]: async ({ commit }: any, payload: string) => {
      commit(SET_LEAVE_LEDGER, { data: null, isLoading: true });

      const result: AxiosResponse =
        await LeaveLedgerService.deleteLeaveLedger(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_LEDGER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_LEDGER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_LEDGER, { isLoading: false });
        return false;
      }
    },
    [CLEAR_LEAVE_LEDGER_ISLOADING]: ({ commit }) => {
      commit(SET_LEAVE_LEDGER, { isLoading: false });
      commit(SET_LEAVE_LEDGERS, { isLoading: false });
    },
  },
};

export default leaveLedger;
